import ky from "ky";

export default ky.create({ prefixUrl: "https://devapi.solagame.io/v1" });
